import {z} from 'zod';

/**
 * Title schema for PebblePlot graphs
 * Allows customization of title text and styling
 */
export const pebbleplotTitleSchema = z
  .object({
    text: z.string(), // Required: Title text to display
    fontSize: z.union([z.string(), z.number()]).optional(), // Optional: CSS font size (e.g., "16px", "1.2rem", or number)
    color: z.string().optional(), // Optional: CSS color (e.g., "#000000", "primary.main")
    offsetX: z.union([z.string(), z.number()]).optional(), // Optional: Horizontal offset (e.g., "10px", "5%", or number)
    offsetY: z.union([z.string(), z.number()]).optional(), // Optional: Vertical offset (e.g., "10px", "5%", or number)
    padding: z.union([z.string(), z.number()]).optional(), // Optional: CSS padding (e.g., "10px", "1rem", or number)
    margin: z.union([z.string(), z.number()]).optional(), // Optional: CSS margin (e.g., "10px", "1rem", or number)
  })
  .optional();

export type PebblePlotTitle = z.infer<typeof pebbleplotTitleSchema>;
